import { markPreferenceSet, applyPreferences } from '../utils/localePreferences'
import { trackAmplitudeEvent } from '../analytics/CustomEvents'

export default function initLocaleSelectorModal () {
  const modal = document.getElementById('vjs-locale-selector-modal')
  if (!modal) return
  initOptionToggling(modal)

  const confirmBtn = modal.querySelector('.vjs-locale-selector-confirm')
  const dismissBtn = modal.querySelector('.vjs-locale-selector-dismiss')

  if (confirmBtn) confirmBtn.addEventListener('click', () => confirmSelection(modal))
  if (dismissBtn) dismissBtn.addEventListener('click', markPreferenceSet)

  modal.addEventListener('click', e => e.target === modal && markPreferenceSet())
  modal.classList.add('show')
}

function initOptionToggling (modal) {
  const options = modal.querySelectorAll('.vjs-locale-option')
  options.forEach(option => {
    option.addEventListener('click', () => {
      const group = option.dataset.group
      const groupOptions = modal.querySelectorAll(`.vjs-locale-option[data-group="${group}"]`)
      groupOptions.forEach(other => setOptionSelected(other, false))
      setOptionSelected(option, true)
    })
  })
}

function confirmSelection (modal) {
  const language = getSelectedValue(modal, 'language') || 'en'
  const currency = getSelectedValue(modal, 'currency') || 'gbp'
  applyPreferences(language, currency)
  trackAmplitudeEvent('Locale Selector Option Applied', {
    'Chosen Language': language,
    'Chosen Currency': currency.toUpperCase()
  })
}

function setOptionSelected (option, isSelected) {
  option.dataset.selected = isSelected
  option.classList.toggle('vsd-button__filled', isSelected)
  option.classList.toggle('vsd-button__outlined', !isSelected)
}

function getSelectedValue (modal, group) {
  const selected = modal.querySelector(`.vjs-locale-option[data-group="${group}"][data-selected="true"]`)
  return selected ? selected.dataset.value : ''
}
